import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// Returns the tenant's planKey (e.g. "nursinghome") or "" while loading / not applicable.
// Kept separate from useTenantPageAccess so that hook's return shape stays unchanged.
export default function useTenantPlanKey(tenantId) {
  const id = String(tenantId || "").trim();
  const [planKey, setPlanKey] = useState("");

  useEffect(() => {
    let ignore = false;

    async function load() {
      if (!id) {
        if (!ignore) setPlanKey("");
        return;
      }
      try {
        const snap = await getDoc(doc(db, "tenants", id));
        if (!ignore) setPlanKey(snap.exists() ? String(snap.data()?.planKey || "") : "");
      } catch {
        if (!ignore) setPlanKey("");
      }
    }

    load();
    return () => { ignore = true; };
  }, [id]);

  return planKey;
}
